import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router-dom';

/**
 * Sentryの初期化
 */
export const initSentry = () => {
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  const environment = import.meta.env.MODE;

  // DSNが設定されていない場合は初期化しない（開発環境など）
  if (!dsn) {
    console.warn('Sentry DSN is not configured. Sentry will not be initialized.');

    return;
  }

  Sentry.init({
    dsn,
    environment,
    integrations: [
      // React Router統合
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      // セッションリプレイ（オプション）
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    // パフォーマンスモニタリングのサンプリングレート (0.0 - 1.0)
    tracesSampleRate: 0.1,
    // セッションリプレイのサンプリングレート
    replaysSessionSampleRate: 0.1,
    // エラー発生時のリプレイサンプリングレート
    replaysOnErrorSampleRate: 1.0,
  });
};
